<div class="" [title]="address">
    {{address | tkSlice:40}}
</div>
